export const MESSAGES = "Messages";